export default function SearchResultsSortingOptionsEventModel(sortMethod: string) {
    return {
        sortMethod,
    }
}